<template>
    <div class="input-select-wrapper">
        <select
            v-model="localValue"
            :id="elementId"
            :class="disabledClass"
            :disabled="isDisabled"
            :at-a-input-select="atAttribute"
            class="a-input-select input-select"
            @blur="handleBlur"
        >
            <template v-if="isOptionsList">
                <option
                    v-for="(option, idx) in optionsList"
                    :key="idx"
                    :value="option.value"
                    :disabled="option.isDisabled"
                >
                    {{ option.text }}
                </option>
            </template>
            <template v-else>
                <option value="">Nothing to select</option>
            </template>
        </select>
    </div>
</template>

<script>

export default {
    name: 'AInputSelect',
    props: {
        /**
         * Set id attribute
         */
        elementId: {
            type: String,
            default: null
        },
        /**
         * Set disabled attribute
         */
        isDisabled: {
            type: Boolean,
            default: false
        },
        /**
         * Set input value
         */
        value: {
            type: [String, Number],
            default: null
        },
        /**
         * Locator for automating tests
         */
        atAttribute: {
            type: String,
            default: ''
        },
        /**
         * Set options list for select
         */
        optionsList: {
            type: Array,
            default: () => [{value: '', text: 'Nothing to select'}]
        }
    },
    computed: {
        localValue: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        },
        disabledClass() {
            return this.isDisabled ? 'input-select--disabled' : null;
        },
        isOptionsList() {
            return this.optionsList.length
        },
    },
    methods: {
        handleBlur(e) {
            this.$emit('blur', e);
        }
    }
};
</script>

<style lang="scss">
    @import 'theme';
</style>
